import {
  BaseElementWidget,
  CustomWidget,
  SPI,
  ViewType
} from '@kunlun/dependencies';
import InvoiceInfoManagePage from '../../components/InvoiceInfoManagePage.vue';

/**
 * 开票信息管理页 - 完全自定义 Widget
 */
@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Table,
    widget: ['InvoiceInfoManagePage']
  })
)
export class InvoiceInfoManageWidget extends CustomWidget {
  public initialize(props: any) {
    super.initialize(props);
    this.setComponent(InvoiceInfoManagePage);
    return this;
  }
}
